<template>
  <div
    class="d-flex-row space-between"
    v-for="packSelectedOption in selectedOptions"
    :key="packSelectedOption"
  >
    <div class="d-flex-row justify-start flex-8">
      <p
        class="t-grey font-family-2 regular-l"
        style="text-transform: uppercase"
      >
        {{ packSelectedOption.weapon }}
        <span v-if="packSelectedOption.category">
          -
          {{
            $t(`${currentGameSlug}.type.${packSelectedOption.category}`)
          }}</span
        >
      </p>
    </div>
    <p class="t-white font-family-2 bold-l">
      {{ renderPrice(packSelectedOption) }}
    </p>
  </div>

  <div
    class="d-flex-row space-between"
    v-if="checkoutStore?.getCamoSpecials?.id"
  >
    <p class="t-grey font-family-2 regular-l" style="text-transform: uppercase">
      {{ checkoutStore?.getCamoSpecials?.title }}
    </p>
    <p class="t-white font-family-2 bold-l">
      {{ getUserCurrencyCode }}{{ checkoutStore?.getCamoSpecials?.price }}
    </p>
  </div>
</template>

<script setup>
import { useUserStore } from "#imports";
import { calculateCurrency } from "../../../calculate/calculatePrice";
const { currentGameSlug } = useGameComposable();
const { getGame, getGamePack } = useGameStore();
const checkoutStore = useCheckoutStore();
const { getUserCurrencyCode } = useUserStore();

const renderPrice = (option) => {
  const pp = option.price + (option.catPrice * option.price) / 100;
  if (pp > 0) {
    return `${getUserCurrencyCode}${parseFloat(calculateCurrency(pp)).toFixed(
      2
    )}`;
  }
  return "";
};

const selectedOptions = computed(() => {
  if (checkoutStore.getCamoWeapon?.length > 0) {
    return checkoutStore.getCamoWeapon;
  }
  return [];
});
</script>
